import { useTranslation } from 'react-i18next';
export default function HeroSection() {
const { t, i18n } = useTranslation();
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] lg:min-h-[780px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/6489a824-10a8-4047-916b-1e3e62578ec7/ecad70fa-b962-4326-8b0c-11eb12c8e888_compressed_ameera-ngIdunm1jDs-unsplash.webp"
          alt="Panoramablick auf die Große Pyramide von Gizeh unter dramatisch blauem Wüstenhimmel"
          className="w-full h-full object-cover object-center"
        />
      </div>

      {/* Subtle dark overlay ~35% for readability */}
      <div className="absolute inset-0 bg-primary-950/35" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 md:px-6 pt-20 md:pt-24 pb-12">
        <div className="w-full max-w-3xl mx-auto">
          {/* Brand Tagline — subtle and refined */}
          <p className="text-accent-400 text-xs md:text-sm font-medium tracking-[0.3em] uppercase mb-8 md:mb-10">
            Yallabina Tours
          </p>

          {/* Main Headline — 25% smaller, bold but refined */}
          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-8 md:mb-10 leading-[1.12] tracking-tight">
  {t('hero_headline')}
          </h1>

          {/* Subheadline — crisp white, highly readable */}
          <p className="text-background-50 text-sm sm:text-base md:text-lg max-w-2xl mx-auto mb-12 md:mb-14 leading-relaxed font-normal">
  {t('hero_subheadline')}
          </p>

          {/* CTAs — refined with breathing room */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-20 md:mb-28">
            {/* Primary CTA */}
            <button
              onClick={() => {
                const el = document.getElementById('hurghada-tours');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group w-full sm:w-auto px-9 py-3.5 md:px-11 md:py-4 bg-accent-500 text-primary-950 text-sm md:text-base font-semibold rounded-sm hover:bg-accent-400 transition-all duration-300 cursor-pointer whitespace-nowrap uppercase tracking-wider shadow-[0_6px_24px_rgba(212,175,55,0.2)] hover:shadow-[0_10px_36px_rgba(212,175,55,0.35)]"
            >
              <span className="flex items-center gap-2.5">
                <i className="ri-compass-3-line text-lg group-hover:rotate-12 transition-transform duration-300" />
                {t('hero_cta_primary')}
              </span>
            </button>

            {/* Secondary CTA */}
            <a
              href="https://wa.me/201000932585"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full sm:w-auto px-9 py-3.5 md:px-11 md:py-4 border border-background-50/20 text-background-50 text-sm md:text-base font-medium rounded-sm hover:border-accent-400/60 hover:text-accent-400 hover:bg-background-50/[0.04] transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2.5 backdrop-blur-sm"
            >
              <i className="ri-whatsapp-line text-lg text-accent-400 group-hover:scale-110 transition-transform duration-300" />
              {t('hero_cta_secondary')}
            </a>
          </div>

          {/* Trust Badges — photographic cards with clear white text */}
          <div className="grid grid-cols-2 md:flex md:flex-nowrap justify-center gap-4 md:gap-6">
            {/* No Deposit */}
            <div
              className="relative overflow-hidden flex flex-col items-center justify-center gap-3.5 px-5 py-5 w-full md:w-[240px] h-[140px] md:h-[155px] rounded-sm bg-cover bg-center border-2 border-background-50/30 shadow-lg"
              style={{ backgroundImage: "url('/images/trust-no-deposit.png')" }}
            >
              <div className="absolute inset-0 bg-black/40" />
              <div className="relative z-10 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center">
                <i className="ri-shield-check-line text-accent-400 text-2xl md:text-3xl drop-shadow-md" />
              </div>
              <span className="relative z-10 text-base md:text-lg font-semibold text-white text-center leading-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.9)]">
                {t('trust_no_deposit')}
              </span>
            </div>

            {/* German-speaking Guides */}
            <div
              className="relative overflow-hidden flex flex-col items-center justify-center gap-3.5 px-5 py-5 w-full md:w-[240px] h-[140px] md:h-[155px] rounded-sm bg-cover bg-center border-2 border-background-50/30 shadow-lg"
              style={{ backgroundImage: "url('/images/trust-guides.png')" }}
            >
              <div className="absolute inset-0 bg-black/40" />
              <div className="relative z-10 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center">
                <i className="ri-global-line text-accent-400 text-2xl md:text-3xl drop-shadow-md" />
              </div>
              <span className="relative z-10 text-base md:text-lg font-semibold text-white text-center leading-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.9)]">
                {t(i18n.language === 'de' ? 'trust_german_guides' : 'trust_english_guides')}
              </span>
            </div>

            {/* Private Cars */}
            <div
              className="relative overflow-hidden flex flex-col items-center justify-center gap-3.5 px-5 py-5 w-full md:w-[240px] h-[140px] md:h-[155px] rounded-sm bg-cover bg-center border-2 border-background-50/30 shadow-lg"
              style={{ backgroundImage: "url('/images/trust-private-cars.png')" }}
            >
              <div className="absolute inset-0 bg-black/40" />
              <div className="relative z-10 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center">
                <i className="ri-car-line text-accent-400 text-2xl md:text-3xl drop-shadow-md" />
              </div>
              <span className="relative z-10 text-base md:text-lg font-semibold text-white text-center leading-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.9)]">
                {t('trust_private_cars')}
              </span>
            </div>

            {/* Licensed Egyptologists */}
            <div
              className="relative overflow-hidden flex flex-col items-center justify-center gap-3.5 px-5 py-5 w-full md:w-[240px] h-[140px] md:h-[155px] rounded-sm bg-cover bg-center border-2 border-background-50/30 shadow-lg"
              style={{ backgroundImage: "url('/images/trust-egyptologists.png')" }}
            >
              <div className="absolute inset-0 bg-black/40" />
              <div className="relative z-10 w-10 h-10 md:w-11 md:h-11 flex items-center justify-center">
                <i className="ri-award-line text-accent-400 text-2xl md:text-3xl drop-shadow-md" />
              </div>
              <span className="relative z-10 text-base md:text-lg font-semibold text-white text-center leading-tight drop-shadow-[0_2px_4px_rgba(0,0,0,0.9)]">
                {t('trust_licensed')}
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}